import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserAccessInitialState, IUserAccessPayload } from "../types";
import { GetUserAccess } from "./thunk";

const initialState: IUserAccessInitialState = {
    userAccess: [],
    filterUserAccess: [],
    userAccessRestore: [],
    isLoadingUserAccess: false,
    isViewUserAccessRestore: false,
    selectedUserAccessIDs: [],
};

const userAccessSlice = createSlice({
    name: "userAccess",
    initialState,
    reducers: {
        setUserAccess: (state, action: PayloadAction<IUserAccessPayload[]>) => {
            state.userAccess = action.payload;
        },
        setUserAccessRestore: (state, action) => {
            state.userAccessRestore = action.payload;
        },
        setIsViewUserAccessRestore: state => {
            state.isViewUserAccessRestore = !state.isViewUserAccessRestore;
        },
        deletedUserAccess: (state, action: PayloadAction<number>) => {
            state.userAccess = state.userAccess.filter(elem => elem.id !== action.payload);
        },
        deletedRestoreUserAccess: (state, action) => {
            state.userAccessRestore = state.userAccessRestore.filter(elem => elem.id !== action.payload);
        },
        setSelectedUserAccessIDs: (state, action) => {
            state.selectedUserAccessIDs = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetUserAccess.pending, state => {
                state.isLoadingUserAccess = true;
            })
            .addCase(GetUserAccess.fulfilled, state => {
                state.isLoadingUserAccess = false;
            })
            .addCase(GetUserAccess.rejected, state => {
                state.isLoadingUserAccess = false;
            });
    },
});

export const {
    setUserAccess,
    setUserAccessRestore,
    setIsViewUserAccessRestore,
    deletedUserAccess,
    deletedRestoreUserAccess,
    setSelectedUserAccessIDs,
} = userAccessSlice.actions;

export default userAccessSlice;
